import { Typography } from 'antd';
import type { HTMLAttributes } from 'react';
import tw from 'twin.macro';

interface PriceItemProps {
  price: number;
  discountPrice: number;
  customCss?: HTMLAttributes<unknown>['css'];
}

const PriceItem = ({ price, discountPrice, customCss }: PriceItemProps) => {
  return (
    <div
      css={[
        tw`flex flex-row justify-start items-end mt-[20px] leading-[24px] text-[16px]`,
        tw`x768:(flex-col items-start)`,
        customCss,
      ]}
    >
      <Typography.Text
        css={tw`mr-[8px] font-semibold leading-[24px] text-[16px] text-[#1677ff]`}
      >
        {(price - (discountPrice ?? 0)).toLocaleString()}원
      </Typography.Text>

      {!!discountPrice && (
        <div css={tw`x768:(flex flex-row)`}>
          <Typography.Text css={tw`text-[rgba(0, 0, 0, 0.45)] line-through`}>
            {price.toLocaleString()}원
          </Typography.Text>

          <Typography.Text css={tw`ml-[4px] text-[#ff4d4f]`}>
            - 할인 {discountPrice.toLocaleString()}원
          </Typography.Text>
        </div>
      )}
    </div>
  );
};

export default PriceItem;
